import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Env } from '../../models';
import { SettingsService } from '../../services/settings.service';
import { SpinnerService } from 'src/app/common/services/spinner.service';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-builder',
  templateUrl: './builder.component.html',
  styleUrls: ['./builder.component.sass'],
})
export class BuilderComponent implements OnInit {
  env: Env;
  sourceCollections!: any[];
  targetCollections!: string[];
  error: string | null = null;
  inProgressMessage: string | null = null;

  constructor(
    private router: Router,
    private settingsService: SettingsService,
    private spinnerService: SpinnerService,
    private cdr: ChangeDetectorRef,
    private messageService: MessageService
  ) { }

  async ngOnInit(): Promise<void> {
    this.env = window.location.href.includes('dev.cms') ? 'dev' : (window.location.href.includes('localhost') ? 'local' : (window.location.href.includes('test.cms') ? 'test' : 'prod'));
    // Validate environment and redirect if not local
    if (!this.env || (this.env && 'local' !== this.env)) {
      this.router.navigate(['/home']);
    }

    this.loader();
  }

  async loader() {
    this.spinnerService.loadSpinner();
    this.error = null;
    
    this.targetCollections = [];
    const response = await this.settingsService.getRemoteCollections();

    if (response.success && response.collections?.length > 0) {
      this.sourceCollections = response.collections.map((collection: any) => ({ name: collection }));
      this.cdr.markForCheck();
    } else if (response.error) {
      this.error = response.error;
    }

    this.spinnerService.endSpinner();
  }

  async syncToLocal() {
    this.inProgressMessage = null;
    if (this.targetCollections.length === 0) {
      this.messageService.add({
        severity: 'error',
        summary: 'No collections selected',
        detail: 'You must select at least one collection to sync to local',
        life: 5000
      });
      return;
    }

    try {
      this.spinnerService.loadSpinner();
      const collections = this.targetCollections.map((collection: any) => collection.name);
      const response = await this.settingsService.syncToLocal(collections);
      if (response.success) {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Collections synced to local successfully',
        });
      } else if (response.warning) {
        if (response.warning.indexOf('in progress') !== -1) {
          this.inProgressMessage = response.warning;
        }
        this.messageService.add({
          severity: 'warn',
          summary: 'Warning',
          detail: response.warning,
          life: 5000
        });
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: response.error ||'There was an error syncing to local',
          life: 5000
        });
      }
    } catch (error) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'There was an error syncing to local',
        life: 5000
      });
    } finally {
      this.spinnerService.endSpinner();
    }
  }
}
